<script lang="ts">
	import { dev } from '$app/environment';
	import { page } from '$app/stores';
	import FooterContainer from '$lib/Components/Footer/FooterContainer.svelte';
	import '../app.css';

	$: httpCode = $page.status;
	$: message = $page.error?.message;

	$: dev && console.log($page.error?.detail);
</script>

<div class="flex flex-col min-h-[calc(100vh-230px)]">
	<div class="flex-1 flex flex-col items-center px-[2rem] py-[2rem] justify-center">
		<div>
			<img class="w-[250px]" src="/images/logo-purple.png" alt="logo" />
		</div>

		<h1 class="text-3xl font-poppins-bold text-affair mt-8">
			{#if httpCode === 404}
				Sorry, we are going wrong way!
			{:else}
				Oops, something went wrong!
			{/if}
		</h1>

		<p class="mt-4 text-center font-jakarta-regular">
			{#if httpCode === 404}
				Look like resource you are looking for is not available.
				<br />
				Please check the URL and try again.
			{:else}
				<span>
					Sorry, look like we are having some technical issues.
					<br />
					Please try again later.
				</span>
			{/if}
		</p>

		<a class="=text-affair font-poppins-bold hover:underline mt-8" href="/">Go to Home</a>
	</div>
</div>
<FooterContainer />
